import React from "react";
import { CONFIG } from "../../config/keys";
import axios from "axios";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { createNumberMask } from "redux-form-input-masks";

const currencyMask = createNumberMask({
  prefix: "$",
  decimalPlaces: 2,
  locale: "en-US",
  stripMask: false,
  guide: true
});

class ProductForm extends React.Component {
  render() {
    // console.log(this.props.data.Group.Type);
    const updateProduct = formValues => {
      let updatedata = "";
      updatedata += "{";
      updatedata += 'Name: "' + formValues.Name + '",';
      if (formValues.Brand) {
        updatedata +=
          'Brand@odata.bind: "Brand(' + parseInt(formValues.Brand) + ')",';
      }
      if (formValues.Category) {
        updatedata +=
          'Category@odata.bind: "Category(' +
          parseInt(formValues.Category) +
          ')",';
      }
      if (formValues.StrainType) {
        updatedata +=
          'StrainType@odata.bind: "StrainType(' +
          parseInt(formValues.StrainType) +
          ')",';
      } else {
        updatedata += 'StrainType@odata.bind: "StrainType(1)",';
      }
      if (formValues.TerpeneProfile) {
        updatedata +=
          'TerpeneProfile@odata.bind: "TerpeneProfile(' +
          parseInt(formValues.TerpeneProfile) +
          ')",';
      }
      if (formValues.Price && formValues.Price !== null) {
        updatedata += 'Price: "' + formValues.Price + '",';
      }
      if (formValues.SalePrice && formValues.SalePrice !== null) {
        updatedata += 'SalePrice: "' + formValues.SalePrice + '",';
      }
      updatedata +=
        'Group@odata.bind: "Group(' + parseInt(formValues.Group) + ')",';
      updatedata += 'SubscriptionId: "' + formValues.SubscriptionId + '"';
      updatedata += "}";
      //console.log(updatedata);
      if (formValues.Oid) {
        // UPDATE RECORD
        const EditProductQuery = "/Product(" + parseInt(formValues.Oid) + ")";
        axios({
          method: "put",
          url: CONFIG.API_URL + EditProductQuery,
          data: updatedata,
          headers: {
            "Content-Type": "application/json",
            Auth: CONFIG.API_KEY
          }
        })
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      } else {
        // CREATE RECORD
        const AddProductQuery = "/Product";
        axios({
          method: "post",
          url: CONFIG.API_URL + AddProductQuery,
          data: updatedata,
          headers: {
            "Content-Type": "application/json",
            Auth: CONFIG.API_KEY
          }
        })
          .then(result => {
            this.props.handleCloseReload();
          })
          .catch(error => console.log(error));
      }
    };
    const onSubmit = formValues => {
      // console.log(formValues);
      updateProduct(formValues);
    };
    const renderBrandOptions = () => {
      return this.props.brands.map((record, index) => {
        return (
          <option key={"brand-" + index} value={record.Oid}>
            {record.Name}
          </option>
        );
      });
    };
    const renderCategoryOptions = () => {
      return this.props.categories.map((record, index) => {
        return (
          <option key={"brand-" + index} value={record.Oid}>
            {record.Name}
          </option>
        );
      });
    };
    const renderStrainTypeOptions = () => {
      return this.props.strainTypes.map((record, index) => {
        return (
          <option key={"strain-" + index} value={record.Oid}>
            {record.Name}
          </option>
        );
      });
    };
    const renderTerpeneProfileOptions = () => {
      return this.props.terpeneProfiles.map((record, index) => {
        return (
          <option key={"brand-" + index} value={record.Oid}>
            {record.Name}
          </option>
        );
      });
    };
    return (
      <div className="txt-center">
        <h4>Product</h4>
        <form
          onSubmit={this.props.handleSubmit(onSubmit)}
          className={"show-" + this.props.Group.Type + "-pricing"}
        >
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="Group"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <div>
            <label>Product Name</label>
            <div>
              <Field
                name="Name"
                component="input"
                type="text"
                placeholder="Product Name"
                autoComplete="off"
              />
            </div>
          </div>
          <div className="item-price">
            <label>Price</label>
            <div>
              <Field
                name="Price"
                component="input"
                type="text"
                placeholder="Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div className="item-price">
            <label>Sale Price</label>
            <div>
              <Field
                name="SalePrice"
                component="input"
                type="text"
                placeholder="Sale Price"
                autoComplete="off"
                {...currencyMask}
              />
            </div>
          </div>
          <div>
            <label>Brand</label>
            <div>
              <Field name="Brand" component="select">
                <option value="1">NA</option>
                {renderBrandOptions()}
              </Field>
            </div>
          </div>
          <div>
            <label>Category</label>
            <div>
              <Field name="Category" component="select">
                <option value="1">NA</option>
                {renderCategoryOptions()}
              </Field>
            </div>
          </div>
          <div>
            <label>Strain Type</label>
            <Field name="StrainType" component="select">
              <option value="1">NA</option>
              {renderStrainTypeOptions()}
            </Field>
          </div>
          <div>
            <label>Terpene Profile</label>
            <div>
              <Field name="TerpeneProfile" component="select">
                <option value="1">NA</option>
                {renderTerpeneProfileOptions()}
              </Field>
            </div>
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Submit
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  // **************************
  // FIX REFERENCE LINK FIELDS
  let initVals = [];
  if (ownProps.data.Brand) {
    initVals.Brand = ownProps.data.Brand.Oid;
  } else {
    initVals.Brand = "";
  }
  if (ownProps.data.Category) {
    initVals.Category = ownProps.data.Category.Oid;
  } else {
    initVals.Category = "";
  }
  if (ownProps.data.StrainType) {
    initVals.StrainType = ownProps.data.StrainType.Oid;
  } else {
    initVals.StrainType = "";
  }
  if (ownProps.data.TerpeneProfile) {
    initVals.TerpeneProfile = ownProps.data.TerpeneProfile.Oid;
  } else {
    initVals.TerpeneProfile = "";
  }
  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Name: ownProps.data.Name,
      Price: ownProps.data.Price,
      SalePrice: ownProps.data.SalePrice,
      InStock: ownProps.data.InStock,
      Brand: initVals.Brand,
      Category: initVals.Category,
      StrainType: initVals.StrainType,
      TerpeneProfile: initVals.TerpeneProfile,
      Group: ownProps.group.Oid,
      SubscriptionId: ownProps.SubscriptionId
    },
    Group: ownProps.group,
    brandsData: ownProps.brandsData,
    brandsCategories: ownProps.brandsCategories,
    strainTypeData: ownProps.strainTypeData,
    terpeneProfiles: ownProps.terpeneProfiles
  };
};

const validate = formValues => {
  const errors = {};

  if (!formValues.Name) {
    errors.Name = "Please enter a product name";
  }

  return errors;
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "ProductForm",
    validate
  })(ProductForm)
);
